import { Navigate } from 'react-router-dom';
import Home from '@/pages/customer/home/Home';
import ProductLayout from '../components/layout/productLayout/ProductLayout';
import Chat from '@/pages/customer/chat/Chat';
import Studio from '@/pages/customer/studio/Studio';
import RestartPasswordPage from '@/pages/restartPassword/RestartPasswordPage';
import OrderStatusPage from '@/pages/orderStatusPage/OrderStatusPage';
import Discover from '@/pages/customer/discover/Discover';
import MySofties from '@/pages/customer/mySofties/MySofties';
import AudioRecordingContextProvider from '@/common/contexts/AudioRecordingContext';

const chatElement = (
	<ProductLayout>
		<AudioRecordingContextProvider>
			<Chat />
		</AudioRecordingContextProvider>
	</ProductLayout>
);

const routes = [
	{
		path: '/',
		element: (
			<ProductLayout>
				<Home />
			</ProductLayout>
		),
	},
	{
		path: '/paywall',
		element: <Navigate to='/chat' replace />,
	},
	{
		path: '/order-status',
		element: <OrderStatusPage />,
	},
	{
		path: '/restart-password/:token',
		element: <RestartPasswordPage />,
	},
	{
		path: '/discover',
		element: (
			<ProductLayout>
				<Discover />
			</ProductLayout>
		),
	},
	{
		path: '/my-softies',
		element: (
			<ProductLayout>
				<MySofties />
			</ProductLayout>
		),
	},
	{
		path: '/chat/:id?',
		element: chatElement,
	},
	{
		path: '/studio',
		element: (
			<ProductLayout>
				<Studio />
			</ProductLayout>
		),
	},
];

export default routes;
